// Player kanban column statuses
export var EPlayerKanbanStatus;
(function (EPlayerKanbanStatus) {
    EPlayerKanbanStatus["NEW"] = "new";
    EPlayerKanbanStatus["PROCESSED"] = "processed";
    EPlayerKanbanStatus["BOOKED"] = "booked";
    EPlayerKanbanStatus["PLAYED"] = "played";
})(EPlayerKanbanStatus || (EPlayerKanbanStatus = {}));
export const PLAYER_KANBAN_STATUS_LABELS = {
    [EPlayerKanbanStatus.NEW]: 'Новый',
    [EPlayerKanbanStatus.PROCESSED]: 'Обработан',
    [EPlayerKanbanStatus.BOOKED]: 'Забронирован',
    [EPlayerKanbanStatus.PLAYED]: 'Сыграл',
};
export const PLAYER_KANBAN_STATUS_COLORS = {
    [EPlayerKanbanStatus.NEW]: '#3B82F6',
    [EPlayerKanbanStatus.PROCESSED]: '#F59E0B',
    [EPlayerKanbanStatus.BOOKED]: '#8B5CF6',
    [EPlayerKanbanStatus.PLAYED]: '#22C55E',
};
